/**
 * Provides JS functionality for tracking alert display.
 */
class Testimoials extends DrupalBehavior {

  onContent(context) {
    // Initialize javascript.
  }

  onReady(document) {
    $('.testimonials__slides-wrapper').each((k, t) => {
      const dotsWrapper = $(t).siblings('.testimonials__dots');
      const slides = $(t).find('.testimonials__slide');
      if (slides.length > 1) {
        $(t).slick({
          appendDots: dotsWrapper,
          arrows: false,
          dots: true,
        });

        if ($(t).find('.slick-current .testimonial--no-image').length > 0) {
          $(t).siblings('.testimonials__dots').addClass('testimonials__dots--no-image');
        } else {
          $(t).siblings('.testimonials__dots').removeClass('testimonials__dots--no-image');
        }

        $(t).on('afterChange', () => {
          if ($(t).find('.slick-current .testimonial--no-image').length > 0) {
            $(t).siblings('.testimonials__dots').addClass('testimonials__dots--no-image');
          } else {
            $(t).siblings('.testimonials__dots').removeClass('testimonials__dots--no-image');
          }
        });
      }
    });
  }

}

DrupalBehavior.register('camc.components', 'testimonials', Testimoials);
